/**
 * example message:
 * {
	"messageType": "alertNotification",
	"notificationId": 1645479752684,
	"notificationDetails": {"updateType":"EXIT_TRIGGERED","notificationType":"TRADE_PLAN_UPDATE","TRADE_PLAN":{"type":"BASIC_TRADING_SYSTEM","id":1,"symbol":"XYZ"}},
	"status": "TACTIC_TRIGGERED",
	"statusDetails": {"pluginTemplate":{"maxMfe":100.0,"mfeRetracePct":0.6,"mfeType":"byPnl","activateSetting":"PERCENT","pnlType":"UNREALIZED"},"triggerPrice":100.0,"tradeDirection":"LONG","tacticName":"MFE_RETRACEMENT","symbol":"XYZ"},
	"date": "2022-02-21T16:42:33.324-0500",
	"timestamp": "1645479753326"
}

 * @param {*} pluginTemplate 
 * @returns an object with fields:
 * 1) maxMfe
 * 2) mfeRetracePct
 * 3) mfeType (byUnderlying, byPositionPrice,byPnl)
 * 4) activateSetting (PERCENT,AMOUNT)
 * 5) pnlType (OVERALL,UNREALIZED)
 */
export function mfeRetracementParser(pluginTemplate) {
  const parsedObject = {
    maxMfe: null,
    mfeRetracePct: null,
    mfeType: null, //byUnderlying, byPositionPrice,byPnl
    activateSetting: null, //PERCENT,AMOUNT
    pnlType: null, //OVERALL,UNREALIZED
  };
  if (pluginTemplate) {
    parsedObject.maxMfe = pluginTemplate.maxMfe;
    parsedObject.mfeRetracePct = pluginTemplate.mfeRetracePct;
    parsedObject.mfeType = pluginTemplate.mfeType;
    parsedObject.activateSetting = pluginTemplate.activateSetting;
    parsedObject.pnlType = pluginTemplate.pnlType;
  }
  return parsedObject;
}
